import React from 'react';

export default function ScrollToTop({ pathname }) {
  React.useEffect(() => {
    // Scrolla il viewport in cima alla pagina.
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth', // Rende lo scroll animato e meno brusco (opzionale)
    });
  }, [pathname]);

  return null;
}
